import React from 'react'
import Create from '../crud/create'
import fields from './fields'

const CreateTimerType = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Timer Type'
      fields={fields}
      apiPath='admin/timer_types'
      successRedirectPath={resource => `/write-now/timer_types/${resource.id}/edit`}
    />
  )
}

export default CreateTimerType
